import { AccountAccessService } from './account-access/account-access.service';

export { AccountAccessService };

export default [AccountAccessService];
